import AxiosAPI from './AxiosAPI';
import utility from '../shared/utility';

class Subscription extends AxiosAPI {
  createSubscription(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v2/account/subscription/subscribe/web', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  switchSubscription(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v2/account/subscription/switch-plan/web', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  fetchSubscriptionPlans(currencyCode, countryCode) {
    const annualPlanEnabled = utility.annualPlanFlag();
    const reqUrl = annualPlanEnabled ? 'v3/zuora/products' : 'v1/zuora/products';
    return new Promise((resolve, reject) => {
      super.getList(reqUrl, { product_type: 'WebStore', currency: currencyCode, country: countryCode }).then((resp) => {
        let plan = null;
        if (resp && resp.success && resp.products.length) {
          const product = resp.products[0];
          [plan] = product.productRatePlans;
        }
        // using new pricing vuex store post annual plan changes
        if (resp && resp.success && resp.products.length && annualPlanEnabled) {
          window.$store.dispatch('setPricingPlans', { response: resp, currencyCode });
        }
        if (resp && resp.success && resp.holiday_promo) {
          plan.holiday_promo = resp.holiday_promo;
        }
        // FIXME TEMPORARY HARD-CODED RESPONSE DATA --END
        resolve({ plan, originalResponse: resp });
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  getSubscription() {
    return new Promise((resolve, reject) => {
      super.getList('v1/account/subscription', {}).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  cancelSubscription() {
    return new Promise((resolve, reject) => {
      super.post('v2/account/subscription/unsubscribe').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  updatePaymentInfo(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v2/account/payment/credit-card', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  fetchTransactionHistory(params) {
    return new Promise((resolve, reject) => {
      super.getList('v1/user/transactions', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  validateAndStorePromoCode(promoData, currency) {
    return new Promise((resolve, reject) => {
      const { activePlan } = window.$store.getters;
      super.get(`v1/zuora/promo/${promoData.promoCode}/validate`, { productRatePlans: activePlan && activePlan.id ? activePlan.id : '', currency }).then((resp) => {
        resolve(resp);
        if (resp && resp.valid) {
          localStorage.setItem('promo_code', promoData.promoCode);
          if (resp.promoData && resp.promoData.ratePlan) {
            const plan = resp.promoData.ratePlan[0];
            if (plan && plan.id) {
              const currentDate = new Date();
              currentDate.setMonth(currentDate.getMonth() + parseInt(plan.upToPeriods, 10));
              localStorage.setItem('promo_trial_end_date', currentDate);
              localStorage.setItem('promo_trial_period', parseInt(plan.upToPeriods, 10));
              promoData.trialPeriod = parseInt(plan.upToPeriods, 10);
              promoData.trialEndDate = currentDate;
              window.$store.dispatch('setPromoData', promoData);
            }
          }
        }
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getTransactionDetails(transactionId) {
    return new Promise((resolve, reject) => {
      super.get(`v1/user/transactions-details/${transactionId}`).then((resp) => {
        if (resp) {
          resolve(resp);
        }
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }

  subscriptionWithOldCard(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('v1/zuora/resubscribe/web', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.message ? error.message : error);
      });
    });
  }
}

export default Subscription;
